/******************************************************************************
 * Copyright (c) 2026 Contributors to the Eclipse Foundation.
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * https://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *****************************************************************************/
import { createRoute } from '../../utils';
export var ExtensionListRoutes;
(function (ExtensionListRoutes) {
    ExtensionListRoutes.MAIN = createRoute([]);
    ExtensionListRoutes.SEARCH = createRoute(['search']);
})(ExtensionListRoutes || (ExtensionListRoutes = {}));
//# sourceMappingURL=extension-list-routes.js.map